import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, Chip, MenuItem } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, TextField, Dialog, DialogContent, DialogTitle, useMediaQuery, FormControl, InputLabel, Select, FormHelperText } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { SUPPORT } from "src/api/axios";
import { SUPPORT_PATH } from 'src/routes/paths';
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import CloseIcon from '@mui/icons-material/Close';
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { useTheme } from '@mui/material/styles';
import { useMutation } from "react-query";
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import useStore from 'src/contexts/AuthProvider'
import moment from "moment";
import { useNavigate } from "react-router";
import AppTooltip from "src/components/common/AppTooltip";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ButtonText from "src/components/common/ButtonText";
const _ = require('lodash');

const SupportTicket = () => {
   const axiosPrivate = useAxiosPrivate();
   const theme = useTheme();
   const navigate = useNavigate();
   const { enqueueSnackbar } = useSnackbar();

   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [openModal, setOpenModal] = useState(false);
   const [modelTitle, setmodelTitle] = useState("");
   const [filterName, setFilterName] = useState('');
   const [Id, setId] = useState("");
   const [deleteId, setdeleteId] = useState("");
   const [open, setOpen] = useState(false);
   const [loading, setLoding] = useState(true);
   const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
   const permissionsData = useStore(state => state.permissions);

   const [subject_id, setSubjectId] = useState('');
   const [supportSubjectData, setSupportSubjectData] = useState();

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'subject', label: 'Subject', alignRight: false },
      { id: 'description', label: 'Description', alignRight: false },
      { id: 'created', label: 'Created Date', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];

   async function getSupportRequest(page, filterName) {
      const response = await axiosPrivate.get(SUPPORT.getSupportRequest, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: supportRequest, refetch } = useQuery(['supportRequest', page, filterName], () => getSupportRequest(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (supportRequest) {
         setTableData(supportRequest.data);
         setRowsPerPage(supportRequest?.metadata.length != 0 ? supportRequest?.metadata[0].limit : 10);
      }
      if (supportRequest?.metadata.length != 0 && supportRequest?.metadata[0].hasMoreData == true) {
         getSupportRequest(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [supportRequest])

   async function getSupportSubject() {
      const response = await axiosPrivate.get(SUPPORT.getSupportSubject)
      return response.data;
   }
   const { data: supportSubject } = useQuery(['supportSubject'], () => getSupportSubject(), { keepPreviousData: true, })
   useEffect(() => {
      if (supportSubject !== undefined) {
         setSupportSubjectData(supportSubject)
      }
   }, [supportSubject])

   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getSupportRequest(page, filterName)
      refetch();
   };

   const completedSchema = Yup.object().shape({
      subject_id: Yup.string().required('Subject is required'),
      description: Yup.string().required('Description is required'),
   });

   const formik = useFormik({
      initialValues: {
         subject_id: "",
         description: "",
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            subject_id: values.subject_id,
            description: values.description,
         };

         await addSupportRequest(informationObj);
         resetForm();
         setSubmitting(false);
      },
   });

   const { mutateAsync: addSupportRequest } = useMutation(
      async (data) => {
         return await axiosPrivate.post(SUPPORT.addSupportRequest, data)
      },
      {
         onSuccess: ({ data }) => {
            enqueueSnackbar("Request add successfully ", {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            handleCloseModal();
            refetch();
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            if (error.response?.data?.message) {
               enqueueSnackbar(error.response?.data?.message, {
                  variant: "error",
                  anchorOrigin: { vertical: "top", horizontal: "right" },
                  autoHideDuration: 2000,
               });
            }
            Object.keys(errorData).forEach((key) => {
               if (key === "subject") {
                  setFieldError("subject", errorData[key]);
               } else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

   const handleClose = () => {
      setOpen(false);
   };

   const deleteSupportRequest = async () => {
      const response = await axiosPrivate.delete(SUPPORT.deleteSupportRequest + deleteId)
      if (response.status == 200) {
         enqueueSnackbar("Request delete successfully", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      } else {
         enqueueSnackbar("something went wrong", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
         });
      }
      refetch();
      handleClose();
   };

   const handleOpenModalAdd = () => {
      setFieldValue('name', "")
      setFieldValue('subject_id', "")
      setId('')
      setmodelTitle('Send Support Request')
      setOpenModal(true);
   };

   const handleClickOpen = (categoryId, categoryType) => {
      setdeleteId(categoryId);
      setOpen(true);
   };

   const handleCloseModal = () => {
      setOpenModal(false);
      resetForm();
   };

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, resetForm, setFieldTouched } = formik;

   const handleViewDetail = (supportData, slug) => {
      if (slug == 'view') {
         navigate(SUPPORT_PATH.general.viewSupportRequest, { state: { supportData: supportData } });
      } else {
         navigate(SUPPORT_PATH.general.editSupportRequest, { state: { supportData: supportData, supportSubjectData: supportSubjectData } });
      }
   }

   const handleFoodCategoryOnChange = (event) => {
      setSubjectId(event.target.value);
   };

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Support Request</h4>
            <Box className="d-flex align-items-center">
               <Paper component="form" className='dashboard_searchbox' sx={{ minWidth: '380px' }}>
                  <IconButton>
                     <SearchIcon />
                  </IconButton>
                  <InputBase
                     fullWidth
                     sx={{ flex: 1 }}
                     placeholder="search ..."
                     onChange={(e) => handleFilterByName(e)}
                     onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                  />
               </Paper>
               <Stack direction={"row"} className="d-flex align-items-center ms-lg-4 ms-2" spacing={2}>
                  {permissionsData?.support_ticket?.substring(1, 2) === "1" ?
                     <AppTooltip title="Add Request" placement="bottom">
                        <ButtonText text={'Send Request'} onClickBtn={() => handleOpenModalAdd()} />
                     </AppTooltip> : ""}
               </Stack>
            </Box>
         </div>
         <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={() => deleteSupportRequest()} autoFocus>
                     delete
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={supportRequest?.data?.length}
                     onRequestSort={handleRequestSort}
                  />
                  {filteredUsers?.length > 0 ?
                     <TableBody>
                        {filteredUsers.map((row) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell align="left"> {row?.subject_data?.name} </TableCell>
                                 <TableCell align="left"> {row.description} </TableCell>
                                 <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status == 1 ? <Chip variant="contained" label="Close" className="app_status_chip accepted" /> : <Chip variant="contained" className="app_status_chip pending" label="Pending" />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {/* {permissionsData?.support_ticket?.substring(3, 4) == "1" ? */}
                                       <AppTooltip title="View" placement="bottom">
                                          <Button sx={{ "&:hover": { bgcolor: "transparent" } }} onClick={() => handleViewDetail(row, 'edit')} variant="text" className="user_list_row_btn"><VisibilityIcon /></Button>
                                       </AppTooltip>
                                       {/* : ''} */}
                                       {/* <AppTooltip title="View" placement="bottom">
                                             <Button sx={{ "&:hover": { bgcolor: "transparent" } }} variant="text" className="user_list_row_btn" onClick={(e) => handleViewDetail(row, 'view')} ><VisibilityIcon /></Button>
                                          </AppTooltip> */}
                                       {/* {permissionsData?.support_ticket?.substring(2, 3) == "1" ?
                                             <AppTooltip title="Delete" placement="bottom">
                                                <Button variant="text" className="user_list_row_btn" onClick={() => handleClickOpen(row._id, "main")} ><BinIcon /></Button>
                                             </AppTooltip> : ""} */}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={supportRequest?.metadata.length != 0 ? supportRequest?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>
         <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>{modelTitle}</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2" sx={{ minWidth: '500px' }}>
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-12">
                           <FormControl fullWidth className="mb-3">
                              <InputLabel id="demo-simple-select-label">Subject</InputLabel>
                              <Select
                                 labelId="demo-simple-select-label"
                                 id="subject_id"
                                 label="Subject"
                                 name="subject_id"
                                 onChange={(e) => {
                                    handleFoodCategoryOnChange(e);
                                    setFieldTouched("subject_id", true)
                                    setFieldValue("subject_id", e.target.value)
                                 }}
                              >
                                 {
                                    supportSubjectData?.map((result, i) => {
                                       return (
                                          <MenuItem value={result._id} key={i} >
                                             {result.name}
                                          </MenuItem>
                                       )
                                    })
                                 }
                              </Select>
                              {errors.subject_id && touched.subject_id && <FormHelperText error>{errors.subject_id}</FormHelperText>}
                           </FormControl>
                        </div>
                        <div className="col">
                           <div className="form-group mb-4">
                              <TextField sx={{ "& .MuiInputBase-input.MuiOutlinedInput-input": { minHeight: '5.5rem' } }} label='Description' multiline name='description' autoComplete='off' fullWidth
                                 {...getFieldProps("description")}
                              />
                              {errors.description && touched.description && <FormHelperText error>{errors.description}</FormHelperText>}
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <Button
                              type="submit"
                              fullWidth
                              variant="contained"
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                           >
                              submit
                           </Button>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default SupportTicket